module.exports = __webpack_public_path__ + "6090bba45be8b4097c60cfee92eadb27.png";